"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-47868fb5"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "maxContent" };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "baseInfo" };
const _hoisted_4 = { key: 1 };
const _hoisted_5 = { class: "main" };
const _hoisted_6 = { class: "bread" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("a", { href: "#" }, "充电桩", -1));
const _hoisted_8 = { href: "#" };
const _hoisted_9 = { class: "mainInfo" };
const _hoisted_10 = { class: "mainInfoLeft" };
const _hoisted_11 = { class: "title" };
const _hoisted_12 = { class: "wrapperAnchor" };
const _hoisted_13 = { class: "itemRight" };
const _hoisted_14 = { class: "itemRow" };
const _hoisted_15 = { class: "suliang" };
const _hoisted_16 = { class: "itemRow" };
const _hoisted_17 = { class: "itemRow row" };
const _hoisted_18 = { class: "itemIcon" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = {
    key: 1,
    class: "maintenance"
};
const _hoisted_21 = { key: 2 };
const _hoisted_22 = { class: "info" };
const _hoisted_23 = {
    key: 0,
    class: "infoContent"
};
const _hoisted_24 = { class: "infoContentLeft" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "img" }, null, -1));
const _hoisted_26 = { class: "infoName" };
const _hoisted_27 = { class: "infoDescription" };
const _hoisted_28 = { key: 0 };
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "坏件标记：", -1));
const _hoisted_30 = { key: 1 };
const _hoisted_31 = { key: 2 };
const _hoisted_32 = {
    key: 0,
    class: "infoContentRight"
};
const vue_3 = require("vue");
const vue_router_1 = require("vue-router");
const ant_design_vue_1 = require("ant-design-vue");
const index_1 = require("../../service/index");
const nulltext_1 = require("./nulltext");
const map_1 = require("../../utils/const/map");
const array_1 = require("../../utils/const/array");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const selectDevice = (0, vue_3.ref)();
        const anchorItems = (0, vue_3.ref)([]);
        const statusValue = (0, vue_3.ref)();
        const isExistManualMarking = (0, vue_3.ref)(false);
        const initFlag = (0, vue_3.ref)(false);
        const handleAimIconClick = () => {
            var _a, _b;
            (_b = document.getElementById((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.titleValue)) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
        };
        const getContainer = () => document.getElementById('list');
        const getCurrentAnchor = () => {
            var _a;
            return (_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.href;
        };
        const setSelectDevice = (href) => {
            var _a;
            selectDevice.value = anchorItems.value.find(item => item.href === href);
            statusValue.value = (_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.status;
            if (isExistManualMarking.value) {
                isExistManualMarking.value = false;
                anchorItems.value = anchorItems.value.map((item, index) => {
                    return item.manualMarking ? Object.assign(Object.assign({}, item), { title: item.titleValue, manualMarking: false }) : item;
                });
            }
        };
        const handleAnchorClick = (e, link) => {
            e.preventDefault();
            setSelectDevice(link.href);
        };
        const handleAnchorChang = (currentActiveLink) => {
            if (initFlag.value) {
                return;
            }
            setSelectDevice(currentActiveLink);
        };
        const handleRadioChange = (event) => __awaiter(this, void 0, void 0, function* () {
            const { suyuanqijiansn } = selectDevice.value;
            const response = yield (0, index_1.updateJQStatus)({
                list: [{
                        suyuanqijiansn,
                        status: event.target.value,
                    }],
            });
            ant_design_vue_1.message.success(response.msg);
            if (response.data) {
                // 请求详情数据
                anchorItems.value = yield requestDeviceInfo(decodeURI(route.query.chengpinsnma || ""));
                selectDevice.value = anchorItems.value.find((item) => selectDevice.value.xuhao === item.xuhao);
            }
        });
        const searchKeywords = (params) => __awaiter(this, void 0, void 0, function* () {
            const { keywords, callback } = params;
            const response = yield (0, index_1.searchSnByKeywords)({
                keywords,
            });
            const data = (response.data || []).map(item => (Object.assign({ label: item.suyuanqijiansn, value: item.suyuanqijiansn }, item)));
            // @ts-ignore
            callback(data);
        });
        const searchCode = (params) => {
            const { sn, stakeQR, deviceSN, selectOption } = params;
            router.replace({
                query: {
                    chengpinsnma: selectOption.chengpinsnma,
                    suyuanqijiansn: selectOption.suyuanqijiansn,
                },
            });
            selectDevice.value = undefined;
            getDeviceInfo(selectOption.chengpinsnma);
        };
        const requestDeviceInfo = (chengpinsnma) => __awaiter(this, void 0, void 0, function* () {
            const response = yield (0, index_1.searchDeviceList)({
                chengpinsnma,
            });
            return (response.data || []).map((item, index) => {
                const newIndex = `${index + 1}`.padStart(2, "0");
                let title = `${newIndex} ${item.suyuanqijianwuliaomingcheng}`;
                let manualMarking = false;
                if (!selectDevice.value
                    && ((route.query.xuhao && item.xuhao === decodeURI(route.query.xuhao))
                        || (!route.query.xuhao && item.suyuanqijiansn === route.query.suyuanqijiansn))) {
                    isExistManualMarking.value = true;
                    manualMarking = true;
                    title = (0, vue_3.h)('span', { style: "color: #f08300", id: title }, `${newIndex} ${item.suyuanqijianwuliaomingcheng}`);
                }
                else {
                    title = (0, vue_3.h)('span', { id: title }, `${newIndex} ${item.suyuanqijianwuliaomingcheng}`);
                }
                return Object.assign(Object.assign({ title, titleValue: `${newIndex} ${item.suyuanqijianwuliaomingcheng}`, key: `${newIndex}`, href: `#${newIndex}_${item.suyuanqijianwuliaomingcheng}`, elementId: `${newIndex}_${item.suyuanqijianwuliaomingcheng}` }, item), { statusText: map_1.deviceStatusMap[item.status], manualMarking });
            });
        });
        const getDeviceInfo = (chengpinsnma) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if (!chengpinsnma) {
                ant_design_vue_1.message.error("缺少成品SN码参数，请检查");
                return;
            }
            anchorItems.value = yield requestDeviceInfo(chengpinsnma);
            selectDevice.value = anchorItems.value.find(item => route.query.xuhao ? item.xuhao === decodeURI(route.query.xuhao || "") : item.suyuanqijiansn === decodeURI(route.query.suyuanqijiansn || "")) || anchorItems.value[0];
            statusValue.value = (_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.status;
            setTimeout(() => {
                var _a, _b;
                (_b = document.getElementById((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.titleValue)) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                setTimeout(() => {
                    var _a, _b;
                    initFlag.value = true;
                    (_b = document.getElementById((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.elementId)) === null || _b === void 0 ? void 0 : _b.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
                    setTimeout(() => {
                        initFlag.value = false;
                    }, 1000);
                }, 1000);
            }, 10);
        });
        const handleClick = () => {
            router.push({
                path: '/deviceInfoList',
                state: {
                    params: {
                        lailiaopici: selectDevice.value.picp,
                    }
                }
            });
        };
        const toBelongPileInfo = () => {
            const { suyuanqijiansn, zhuangerweima } = selectDevice.value;
            router.push({
                path: '/productionInfo',
                query: {
                    xuhao: route.query.xuhao,
                    chengpinsnma: route.query.chengpinsnma,
                    comeFrom: 'device',
                    deviceSN: suyuanqijiansn ? encodeURI(suyuanqijiansn) : undefined,
                    stakeQRCode: zhuangerweima ? encodeURI(zhuangerweima) : undefined,
                }
            });
        };
        (0, vue_3.onMounted)(() => {
            getDeviceInfo(decodeURI(route.query.chengpinsnma || ""));
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g;
            const _component_HeaderNew = (0, vue_2.resolveComponent)("HeaderNew");
            const _component_ArrowLeftOutlined = (0, vue_2.resolveComponent)("ArrowLeftOutlined");
            const _component_a_button = (0, vue_2.resolveComponent)("a-button");
            const _component_a_descriptions_item = (0, vue_2.resolveComponent)("a-descriptions-item");
            const _component_a_descriptions = (0, vue_2.resolveComponent)("a-descriptions");
            const _component_SearchPile = (0, vue_2.resolveComponent)("SearchPile");
            const _component_a_breadcrumb_item = (0, vue_2.resolveComponent)("a-breadcrumb-item");
            const _component_a_breadcrumb = (0, vue_2.resolveComponent)("a-breadcrumb");
            const _component_AimOutlined = (0, vue_2.resolveComponent)("AimOutlined");
            const _component_a_tooltip = (0, vue_2.resolveComponent)("a-tooltip");
            const _component_a_anchor = (0, vue_2.resolveComponent)("a-anchor");
            const _component_SafetyOutlined = (0, vue_2.resolveComponent)("SafetyOutlined");
            const _component_ToolOutlined = (0, vue_2.resolveComponent)("ToolOutlined");
            const _component_a_list_item = (0, vue_2.resolveComponent)("a-list-item");
            const _component_a_list = (0, vue_2.resolveComponent)("a-list");
            const _component_a_radio_group = (0, vue_2.resolveComponent)("a-radio-group");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_HeaderNew),
                (0, vue_2.createElementVNode)("section", _hoisted_2, [
                    (0, vue_2.createVNode)(_component_a_button, {
                        class: "back",
                        onClick: _cache[0] || (_cache[0] = ($event) => ((0, vue_2.unref)(router).back()))
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_ArrowLeftOutlined),
                            (0, vue_2.createTextVNode)("返回 ")
                        ]),
                        _: 1
                    }),
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)(_component_a_descriptions, null, {
                            default: (0, vue_2.withCtx)(() => [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(nulltext_1.deviceBasicInfo), (item) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_descriptions_item, {
                                        key: item.key,
                                        label: item.label,
                                        span: item.span,
                                        class: "descriptionItem"
                                    }, {
                                        default: (0, vue_2.withCtx)(() => {
                                            var _a, _b;
                                            return [
                                                (item.isClick && ((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a[item.key]))
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                                        key: 0,
                                                        href: "#",
                                                        onClick: toBelongPileInfo,
                                                        class: "descriptionValue"
                                                    }, (0, vue_2.toDisplayString)(selectDevice.value[item.key]) + "  点击查询 ", 1))
                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_4, (0, vue_2.toDisplayString)((_b = selectDevice.value) === null || _b === void 0 ? void 0 : _b[item.key]), 1))
                                            ];
                                        }),
                                        _: 2
                                    }, 1032, ["label", "span"]));
                                }), 128))
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createVNode)(_component_SearchPile, {
                        class: "wrapperSearchClass",
                        selectClass: "selectClass",
                        onSearchCode: searchCode,
                        onSearchKeywords: searchKeywords,
                        productionOrDevice: 1,
                        customSearchMethod: true,
                        selectValue: decodeURI((0, vue_2.unref)(route).query.suyuanqijiansn || '')
                    }, null, 8, ["selectValue"])
                ]),
                (0, vue_2.createElementVNode)("main", _hoisted_5, [
                    (0, vue_2.createElementVNode)("nav", _hoisted_6, [
                        (0, vue_2.createVNode)(_component_a_breadcrumb, null, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_a_breadcrumb_item, null, {
                                    default: (0, vue_2.withCtx)(() => [
                                        _hoisted_7
                                    ]),
                                    _: 1
                                }),
                                (0, vue_2.createVNode)(_component_a_breadcrumb_item, null, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a;
                                        return [
                                            (0, vue_2.createElementVNode)("a", _hoisted_8, (0, vue_2.toDisplayString)((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.titleValue), 1)
                                        ];
                                    }),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("section", _hoisted_9, [
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                (0, vue_2.createTextVNode)(" 溯源器件列表 "),
                                (0, vue_2.createVNode)(_component_a_tooltip, null, {
                                    title: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createTextVNode)("列表选中项不可见时，请点击试下")
                                    ]),
                                    default: (0, vue_2.withCtx)(() => [
                                        (0, vue_2.createVNode)(_component_AimOutlined, {
                                            class: "aimIcon",
                                            onClick: handleAimIconClick
                                        })
                                    ]),
                                    _: 1
                                })
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                (0, vue_2.createVNode)(_component_a_anchor, {
                                    wrapperClass: 'anchor',
                                    affix: false,
                                    "target-offset": 0,
                                    items: anchorItems.value,
                                    onClick: handleAnchorClick,
                                    onChange: handleAnchorChang,
                                    getContainer: getContainer,
                                    "get-current-anchor": getCurrentAnchor
                                }, null, 8, ["items"])
                            ])
                        ]),
                        (0, vue_2.createVNode)(_component_a_list, {
                            id: "list",
                            class: "list",
                            "item-layout": "horizontal",
                            "data-source": anchorItems.value
                        }, {
                            renderItem: (0, vue_2.withCtx)(({ item }) => [
                                (0, vue_2.createVNode)(_component_a_list_item, {
                                    class: "listItem",
                                    id: item.elementId
                                }, {
                                    default: (0, vue_2.withCtx)(() => {
                                        var _a, _b;
                                        return [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: (0, vue_2.normalizeClass)(((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.elementId) === item.elementId ? 'activeItem itemLeft' : 'itemLeft')
                                            }, (0, vue_2.toDisplayString)(item.key), 3),
                                            (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                    (0, vue_2.createElementVNode)("div", {
                                                        class: (0, vue_2.normalizeClass)(((_b = selectDevice.value) === null || _b === void 0 ? void 0 : _b.elementId) === item.elementId ? 'activeItem' : '')
                                                    }, "器件SN：" + (0, vue_2.toDisplayString)(item.suyuanqijiansn || "--"), 3),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_15, "数量 " + (0, vue_2.toDisplayString)(item.suyuanqijianshuliang || "--"), 1)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                    (0, vue_2.createElementVNode)("div", null, "器件名称：" + (0, vue_2.toDisplayString)(item.suyuanqijianwuliaomingcheng || "--"), 1),
                                                    (0, vue_2.createElementVNode)("div", {
                                                        class: (0, vue_2.normalizeClass)(item.status === 1 ? 'status normalStatus' : 'normalStatus')
                                                    }, (0, vue_2.toDisplayString)(item.statusText), 3)
                                                ]),
                                                (0, vue_2.createElementVNode)("div", null, "物料号：" + (0, vue_2.toDisplayString)(item.suyuanqijianwuliaobianma || "--"), 1),
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(nulltext_1.detailInfo), (infoItem, index) => {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { key: index }, [
                                                        (0, vue_2.createElementVNode)("template", _hoisted_17, [
                                                            (0, vue_2.createElementVNode)("span", _hoisted_18, [
                                                                (infoItem.key === 'gongyingshang')
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_SafetyOutlined, { key: 0 }))
                                                                    : (0, vue_2.createCommentVNode)("", true),
                                                                (infoItem.key === 'genghuanjiluList')
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_ToolOutlined, { key: 1 }))
                                                                    : (0, vue_2.createCommentVNode)("", true)
                                                            ]),
                                                            (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)(infoItem.label), 1),
                                                            (!infoItem.isMultiple)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_19, (0, vue_2.toDisplayString)(item[infoItem.key] || "--"), 1))
                                                                : (item[infoItem.key])
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_20, [
                                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(item[infoItem.key], (multipleItem, index) => {
                                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", { key: index }, (0, vue_2.toDisplayString)(multipleItem.lingbujiangenghuanshijian) + ", " + (0, vue_2.toDisplayString)(multipleItem.wuliaobianma), 1));
                                                                        }), 128))
                                                                    ]))
                                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_21, "无"))
                                                        ])
                                                    ]));
                                                }), 128))
                                            ])
                                        ];
                                    }),
                                    _: 2
                                }, 1032, ["id"])
                            ]),
                            _: 1
                        }, 8, ["data-source"]),
                        (0, vue_2.createElementVNode)("section", _hoisted_22, [
                            (selectDevice.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                        _hoisted_25,
                                        (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)((_a = selectDevice.value) === null || _a === void 0 ? void 0 : _a.suyuanqijianwuliaomingcheng), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                            ((_b = selectDevice.value) === null || _b === void 0 ? void 0 : _b.suyuanqijiansn)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_28, [
                                                    _hoisted_29,
                                                    (0, vue_2.createElementVNode)("span", null, [
                                                        (0, vue_2.createVNode)(_component_a_radio_group, {
                                                            value: statusValue.value,
                                                            "onUpdate:value": _cache[1] || (_cache[1] = ($event) => ((statusValue).value = $event)),
                                                            options: (0, vue_2.unref)(array_1.deviceStatusArray),
                                                            "option-type": "button",
                                                            onChange: handleRadioChange
                                                        }, null, 8, ["value", "options"])
                                                    ])
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            ((_c = selectDevice.value) === null || _c === void 0 ? void 0 : _c.createTime)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_30, "标记时间：" + (0, vue_2.toDisplayString)((_d = selectDevice.value) === null || _d === void 0 ? void 0 : _d.createTime), 1))
                                                : (0, vue_2.createCommentVNode)("", true),
                                            ((_e = selectDevice.value) === null || _e === void 0 ? void 0 : _e.user)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_31, "标记人员：" + (0, vue_2.toDisplayString)((_f = selectDevice.value) === null || _f === void 0 ? void 0 : _f.user), 1))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ])
                                    ]),
                                    ((_g = selectDevice.value.value) === null || _g === void 0 ? void 0 : _g.picp)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_32, [
                                            (0, vue_2.createVNode)(_component_a_button, { onClick: handleClick }, {
                                                default: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createTextVNode)("同供应商批次查询")
                                                ]),
                                                _: 1
                                            })
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ])
                ])
            ]));
        };
    }
});
